// extracted by mini-css-extract-plugin
export default {"graph":"graph--x78G","trucks":"trucks--8LCN","searches":"searches--MakE"};